import {
defineCustomElement,
MediaMuteButtonElement
} from "vidstack/elements";

defineCustomElement(MediaMuteButtonElement);